"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var updateQueries_1 = require("../../Utils/updateQueries");
var query_string_1 = __importDefault(require("query-string"));
var Tracker_1 = __importDefault(require("../../Utils/Tracker"));
var NavUrl_1 = __importDefault(require("../../Utils/NavUrl"));
var FilterMenu_1 = __importDefault(require("./FilterMenu"));
var Top_1 = __importDefault(require("./FilterMenu/Top"));
var BreadcrumbBar_1 = __importDefault(require("./BreadcrumbBar"));
var SearchInput_1 = __importDefault(require("./SearchInput"));
var SortMenu_1 = __importDefault(require("./SortMenu"));
var mergeDefaultProps_1 = require("../../Utils/mergeDefaultProps");
function ProductList(props) {
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var dimension = reconnect_js_1.useOutlet('dimension')[0];
  var _a = mergeDefaultProps_1.mergeDefaultProps({
      renderCustomSection: null,
      pageContext: {
        outlets: {
          categories: 'categories',
          categoryDisplayMap: 'categoryDisplayMap',
          sortOptions: 'sortOptions'
        },
        prefixPath: '/products',
        detailPrefixPath: '/product',
        collection: 'product',
        layout: {
          left: true,
          right: true
        },
        features: {
          cat: true,
          search: true,
          sort: true,
          breadcrumb: true,
          q: true,
          pageSize: 24
        },
        pageId: 'rev-ProductListPage'
      },
      filterMenuType: 'L3',
      topFilter: false
    }, props),
    ProductGrid = _a.ProductGrid,
    onCustomClick = _a.onCustomClick,
    renderCustomSection = _a.renderCustomSection,
    _b = _a.pageContext,
    outlets = _b.outlets,
    prefixPath = _b.prefixPath,
    detailPrefixPath = _b.detailPrefixPath,
    collection = _b.collection,
    layout = _b.layout,
    features = _b.features,
    pageId = _b.pageId,
    filterMenuType = _a.filterMenuType,
    topFilter = _a.topFilter;
  var PAGE_SIZE = features.pageSize;
  var _c = react_1.default.useState([]),
    products = _c[0],
    setProducts = _c[1];
  var _d = react_1.default.useState(0),
    productTotal = _d[0],
    setProductTotal = _d[1];
  var _e = react_1.default.useState(false),
    mobileFilterVisible = _e[0],
    setMobileFilterVisible = _e[1];
  var params = query_string_1.default.parse(props.location.search);
  var cat = params.cat,
    sort = params.sort,
    search = params.search,
    q = params.q,
    _f = params.page,
    page = _f === void 0 ? 1 : _f;
  var mobile = dimension.rwd === 'mobile';
  react_1.default.useEffect(function () {
    function fetchProducts() {
      return __awaiter(this, void 0, void 0, function () {
        var resp, _productsArr, ex_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2, 3, 4]);
              AppActions.setLoading(true);
              return [4 /*yield*/, AppActions.clientJStorageFetch(collection, {
                cat: cat,
                sort: sort,
                search: search,
                q: q,
                page: {
                  offset: page ? (Number(page) - 1) * PAGE_SIZE : 0,
                  limit: PAGE_SIZE
                }
              })];
            case 1:
              resp = _a.sent();
              _productsArr = [];
              _productsArr = resp.results;
              setProductTotal(resp.total);
              setProducts(_productsArr);
              if (collection === 'Article_Default') {
                Tracker_1.default.viewList({
                  name: collection,
                  list: _productsArr.map(function (p) {
                    return {
                      id: p.id,
                      name: p.title
                    };
                  })
                });
              } else {
                Tracker_1.default.viewList({
                  name: collection,
                  list: _productsArr
                });
              }
              setMobileFilterVisible(false);
              return [3 /*break*/, 4];
            case 2:
              ex_1 = _a.sent();
              console.warn(ex_1);
              return [3 /*break*/, 4];
            case 3:
              AppActions.setLoading(false);
              return [7 /*endfinally*/];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    }

    fetchProducts();
  }, [cat, sort, search, q, page, collection, AppActions, PAGE_SIZE]);
  var _renderCustomSection = react_1.default.useCallback(function (sectionId) {
    if (renderCustomSection && typeof renderCustomSection === 'function') {
      return renderCustomSection({
        route: prefixPath,
        sectionId: sectionId,
        params: params
      });
    }
    // customRenderFunc backward compatibility
    if (AppActions.renderCustomSection) {
      return AppActions.renderCustomSection({
        route: prefixPath,
        sectionId: sectionId,
        params: params
      });
    }
    return null;
  }, [AppActions, params, prefixPath, renderCustomSection]);
  function updateRoute(options) {
    console.log('in update route', options);
    var nextQueryString = updateQueries_1.updateQueries({
      keys: ['cat', 'sort', 'search', 'q', 'page'],
      params: params,
      options: options
    });
    var _nextUrl = "" + prefixPath + nextQueryString;
    var _a = query_string_1.default.parseUrl(_nextUrl),
      url = _a.url,
      query = _a.query;
    var navUrl = new NavUrl_1.default(url, query);
    AppActions.navigate(navUrl);
  }
  function onItemClick(item) {
    if (collection === 'Article_Default') {
      Tracker_1.default.selectItem({
        name: collection,
        item: {
          id: item.id,
          name: item.title
        }
      });
    } else {
      Tracker_1.default.selectItem({
        name: collection,
        item: item
      });
    }
    var _nextUrl = detailPrefixPath + "?id=" + item.id;
    var _a = query_string_1.default.parseUrl(_nextUrl),
      url = _a.url,
      query = _a.query;
    var navUrl = new NavUrl_1.default(url, query);
    AppActions.navigate(navUrl);
  }
  return react_1.default.createElement(Wrapper, {
    id: pageId
  }, _renderCustomSection('A'), react_1.default.createElement("div", {
    className: "content"
  }, _renderCustomSection('B'), topFilter && react_1.default.createElement(Top_1.default, {
    cat: cat,
    updateCat: function updateCat(cat) {
      return updateRoute({
        cat: cat,
        page: ''
      });
    },
    categories: outlets.categories
  }), react_1.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, !mobile && layout.left && react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, _renderCustomSection('C'), features.cat && !topFilter && react_1.default.createElement(FilterMenu_1.default, {
    cat: cat,
    updateCat: function updateCat(cat) {
      return updateRoute({
        cat: cat,
        page: ''
      });
    },
    categories: outlets.categories,
    type: filterMenuType
  }), _renderCustomSection('D')), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1
    }
  }, _renderCustomSection('E'), react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, features.breadcrumb && react_1.default.createElement("div", {
    style: {
      padding: 'var(--basePadding)'
    }
  }, react_1.default.createElement(BreadcrumbBar_1.default, {
    cat: cat,
    updateCat: function updateCat(cat) {
      return updateRoute({
        cat: cat
      });
    },
    categoryDisplayMap: outlets.categoryDisplayMap
  })), react_1.default.createElement("div", {
    style: {
      margin: '0px 10px'
    }
  }), (features.sort || features.search) && react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      alignItems: 'center',
      padding: 'var(--basePadding)'
    }
  }, features.sort && react_1.default.createElement(SortMenu_1.default, {
    sort: sort,
    updateSort: function updateSort(sort) {
      return updateRoute({
        sort: sort
      });
    },
    sortOptions: outlets.sortOptions
  }), features.search && react_1.default.createElement(SearchInput_1.default, {
    search: search,
    updateSearch: function updateSearch(search) {
      return updateRoute({
        search: search
      });
    }
  }))), _renderCustomSection('F'), _renderCustomSection('G'), react_1.default.createElement(ProductGrid, {
    products: products,
    onItemClick: onCustomClick && function (item) {
      Tracker_1.default.selectItem({
        name: collection,
        item: item
      });
      onCustomClick(item);
    } || onItemClick,
    prefixPath: prefixPath
  }), react_1.default.createElement(antd_1.Pagination, {
    style: {
      margin: '0 auto'
    },
    showSizeChanger: false,
    defaultCurrent: 1,
    current: Number(page),
    pageSize: PAGE_SIZE,
    total: productTotal,
    onChange: function onChange(page, pageSize) {
      return updateRoute({
        page: page
      });
    }
  }), _renderCustomSection('H')), !mobile && layout.right && _renderCustomSection('I')), mobile && _renderCustomSection('I'), _renderCustomSection('J')), _renderCustomSection('K'), mobile && features.cat && !topFilter && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Backdrop, {
    visible: mobileFilterVisible,
    onClick: function onClick() {
      return setMobileFilterVisible(false);
    }
  }), react_1.default.createElement(MobileFilter, {
    visible: mobileFilterVisible
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, _renderCustomSection('C'), react_1.default.createElement(FilterMenu_1.default, {
    cat: cat,
    updateCat: function updateCat(cat) {
      return updateRoute({
        cat: cat,
        page: ''
      });
    },
    categories: outlets.categories,
    type: filterMenuType,
    mobile: true
  }), _renderCustomSection('D'))), react_1.default.createElement(MobileMenuBtn, {
    className: "rev-mobile-menu-btn",
    onClick: function onClick() {
      return setMobileFilterVisible(!mobileFilterVisible);
    }
  }, react_1.default.createElement(antd_1.Button, {
    type: "primary"
  }, AppActions.L('list')))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: var(--contentMaxWith);\n    margin: 0 auto;\n  }\n"], ["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: var(--contentMaxWith);\n    margin: 0 auto;\n  }\n"])));
var MobileMenuBtn = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 84px;\n  right: -8px;\n"], ["\n  position: fixed;\n  top: 84px;\n  right: -8px;\n"])));
var MobileFilter = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  z-index: 100;\n  position: fixed;\n  background-color: white;\n  top: 0;\n  left: 0;\n  opacity: ", ";\n  overflow: auto;\n  height: 100vh;\n  transform: ", ";\n  transition: 180ms;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\n"], ["\n  z-index: 100;\n  position: fixed;\n  background-color: white;\n  top: 0;\n  left: 0;\n  opacity: ", ";\n  overflow: auto;\n  height: 100vh;\n  transform: ", ";\n  transition: 180ms;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\n"])), function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 'translateX(0px)' : 'translateX(-300px)';
});
var Backdrop = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  z-index: 99;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 180ms;\n  opacity: ", ";\n  background-color: rgba(0, 0, 0, 0.5);\n  pointer-events: ", ";\n"], ["\n  z-index: 99;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 180ms;\n  opacity: ", ";\n  background-color: rgba(0, 0, 0, 0.5);\n  pointer-events: ", ";\n"])), function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 'auto' : 'none';
});
exports.default = ProductList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;